// Used to test with dev site API, DO NOT commit this
// const API_URL = process.env.REACT_APP_API_URL || 'https://coriolis-otfp-kosmos-api-dev.azurewebsites.net';
// const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'https://coriolis-otfp-kosmos-api-dev.azurewebsites.net/hubs/chat';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:44326';
const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'https://localhost:44326/hubs/chat';

const drawerWidth = 280;

// azure aadb2c settings
const AZURE_B2C_CONFIG = {
  redirectPath: process.env.REACT_APP_REDIRECT_PATH || '/home',
  logoutRedirectPath: process.env.REACT_APP_POST_LOGOUT_REDIRECT_PATH || '/',
  simpleSignup: process.env.REACT_APP_SIMPLE_SIGNUP // simple signup will disable email/phone verification
};

export {
  AZURE_B2C_CONFIG,
  API_URL,
  WEBSOCKET_URL,
  drawerWidth,
};